import editIcon from "../../../../assets/edit.svg";
import { Divider, Dropdown, Form } from "antd";
import { DeleteOutlined, EllipsisOutlined } from "@ant-design/icons";
import "../../../../components/modals/invitations/styles.css";
import { useTranslation } from "react-i18next";
import AssociationsBlock from "../../../../components/associations/associations-block";

const CollapseExtraItem = ({ categoryId, onClick, remove, categoryName }) => {
  const items = [
    {
      key: "1",
      "data-testid": "category-delete",
      label: "Delete",
      icon: <DeleteOutlined />,
      onClick: () => remove(categoryId, categoryName),
    },
  ];

  return (
    <Dropdown
      menu={{
        items,
        onClick,
      }}
      trigger={["click"]}
      styles={{ root: { width: 120 } }}
    >
      <EllipsisOutlined
        data-testid="category-menu"
        style={{ cursor: "pointer", width: 30 }}
        onClick={(e) => {
          e.stopPropagation();
        }}
      />
    </Dropdown>
  );
};

const CategoryCardView = ({
  category,
  toEditMode,
  deleteCategory,
  form,
  associationGroups = [],
}) => {
  const { name, description } = category || {};
  const { t } = useTranslation();

  return (
    <div
      className="categories-modal"
      style={{ position: "relative", bottom: 16 }}
    >
      <Divider />
      <div className="task-drawer__header pl11">
        <div />
        <div className="categories__modal-header__right">
          <CollapseExtraItem
            categoryName={category?.name}
            categoryId={category?.id}
            remove={deleteCategory}
          />
          <img data-testid="category-edit" src={editIcon} alt="edit" onClick={toEditMode} />
        </div>
      </div>

      <Form form={form}>
        <Form.Item key={"name"}>
          <div className="invite-user__field">
            <p className="invite-user__field__name">
              {t("categories.modal.name")}
            </p>
            <p className="categories-drawer__body__title">{name}</p>
          </div>
        </Form.Item>

        <Form.Item key={"description"}>
          <div className="invite-user__field">
            <p className="invite-user__field__name">
              {t("categories.modal.description")}
            </p>
            <p className="categories-drawer__body__description">
              {description}
            </p>
          </div>
        </Form.Item>
      </Form>

      {associationGroups?.length ? (
        <AssociationsBlock groups={associationGroups} />
      ) : null}
    </div>
  );
};

export default CategoryCardView;